import { render, staticRenderFns } from "./SelectLoaction.vue?vue&type=template&id=589f913f&scoped=true&"
import script from "./SelectLoaction.vue?vue&type=script&lang=js&"
export * from "./SelectLoaction.vue?vue&type=script&lang=js&"
import style0 from "./SelectLoaction.vue?vue&type=style&index=0&id=589f913f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f913f",
  null
  
)

export default component.exports